// Texty ikony dopravy zdarma na detaile produktu (freeShipMark.js).
export default {
  /** značka vpravo dole na fotke, pod ikonou nákladiaku */
  mark: 'zadarmo',
  /** riadok v nákupnom boxe: tučná časť + zvyšok */
  rowStrong: 'Doprava zadarmo',
  rowRest: 'na výdajné miesto',
};
